if (!customElements.get('lg-cart-upsell')) {
  customElements.define('lg-cart-upsell', class LgCartUpsell extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      this.boundRefresh = () => this.refresh();
      document.addEventListener('theme:cartchanged', this.boundRefresh);

      this.addEventListener('click', (evt) => {
        const btn = evt.target.closest('.lg-cart-upsell__add-btn');
        if (!btn || btn.disabled) return;
        if (btn.classList.contains('lg-cart-upsell__add-btn--removable') && btn.dataset.lineKey) {
          this.handleRemove(btn);
        } else if (btn.dataset.variantId) {
          this.handleAdd(btn);
        }
      });

      // Stale cart on load: below threshold but free upsell items are still in
      // the cart (e.g. shopper left and came back). Clean them up on connect.
      const keys = (this.dataset.upsellKeys || '')
        .split(',')
        .filter((key) => key.length > 0);
      if (this.dataset.thresholdMet !== 'true' && keys.length > 0) {
        this.removeUpsellItems(keys);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cartchanged', this.boundRefresh);
    }

    handleAdd(button) {
      const variantId = parseInt(button.dataset.variantId, 10);
      if (!variantId) return;

      button.classList.add('lg-cart-upsell__add-btn--loading');
      button.disabled = true;

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { '_upsell': 'true' }
          }]
        })
      })
      .then((response) => {
        if (!response.ok) throw response;
        document.dispatchEvent(
          new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
        );
      })
      .catch((error) => {
        button.classList.remove('lg-cart-upsell__add-btn--loading');
        button.disabled = false;

        if (error instanceof Response) {
          error.json().then((data) => {
            const msg = data.description || data.message || 'Could not add item';
            this.showError(button, msg);
          }).catch(() => {
            this.showError(button, 'Could not add item');
          });
        }
      });
    }

    handleRemove(button) {
      const lineKey = button.dataset.lineKey;
      if (!lineKey) return;

      button.classList.add('lg-cart-upsell__add-btn--loading');
      button.disabled = true;

      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then((response) => {
          if (!response.ok) throw response;
          document.dispatchEvent(
            new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
          );
        })
        .catch(() => {
          button.classList.remove('lg-cart-upsell__add-btn--loading');
          button.disabled = false;
          this.showError(button, 'Could not remove item');
        });
    }

    showError(button, message) {
      const tile = button.closest('.lg-cart-upsell__tile');
      if (!tile) return;

      let errorEl = tile.querySelector('.lg-cart-upsell__error');
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'lg-cart-upsell__error';
        errorEl.style.cssText = 'color:#8b0000;font-size:0.7rem;margin:4px 0 0;';
        tile.appendChild(errorEl);
      }
      errorEl.textContent = message;

      setTimeout(() => {
        if (errorEl.parentNode) errorEl.remove();
      }, 4000);
    }

    refresh() {
      return fetch(`${window.Shopify.routes.root}?section_id=${this.sectionId}`)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const temp = document.createElement('div');
          temp.innerHTML = html;

          const newSection = temp.querySelector('lg-cart-upsell');
          if (!newSection) return;

          this.innerHTML = newSection.innerHTML;

          if (newSection.dataset.upsellCount) {
            this.dataset.upsellCount = newSection.dataset.upsellCount;
          }
          this.dataset.thresholdMet = newSection.dataset.thresholdMet || '';
          this.dataset.upsellKeys = newSection.dataset.upsellKeys || '';

          // Below threshold but free upsell items are still in the cart: remove them.
          const thresholdMet = newSection.dataset.thresholdMet === 'true';
          const keys = (newSection.dataset.upsellKeys || '')
            .split(',')
            .filter((key) => key.length > 0);

          if (!thresholdMet && keys.length > 0) {
            this.removeUpsellItems(keys);
          }
        });
    }

    removeUpsellItems(keys) {
      // Guard against re-entrancy: the removal dispatches theme:cartchanged,
      // which re-runs refresh(); by then the items are gone and keys is empty.
      if (this.removing) return;
      this.removing = true;

      const updates = {};
      keys.forEach((key) => { updates[key] = 0; });

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
        .then((response) => {
          if (!response.ok) throw response;
          document.dispatchEvent(
            new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
          );
        })
        .finally(() => {
          this.removing = false;
        });
    }
  });
}
